import { createContext } from 'react';

import { Context } from '../../../types';
import { Class } from '../types';
import api from '../api';
import { getContextDefaultValues } from '../../providersDataManager';

const ClassesContext = createContext<Context<Class>>(getContextDefaultValues(api));
export default ClassesContext;
